import * as Routes from '../routes';

export const COMERCIO = 0;
export const DETALLE = 1;
export const REPRESENTANTE = 2;
export const DOCUMENTOS = 3;
export const VALIDACION = 4;
export const PASSWORD = 5;
export const PERSONA = 6;

export const titleFundsOut = 'Retiro de dinero';

export const NAV_TITLE = [
  {
    screen: [
      Routes.INITIAL_FORM,
      Routes.PERSON_FORM,
      Routes.PERSON_DETAILS_FORM,
      Routes.COMMERCE_FORM,
      Routes.VALIDATE_AND_CREATE_PASSWORD,
      Routes.VALIDATE_DATA_FORM,
      Routes.DOCUMENT_FORM,
      Routes.VALIDATION_FORM,
      Routes.ACCOUNT_CREATED,
      Routes.USER_INVITE_FORM,
      Routes.USER_INVITE_ROLES,
    ],
    title: 'Crear cuenta | Fpay Comercios',
    titleWording: 'documentTitle.createAccount',
  },
  {
    screen: [Routes.LOGIN],
    title: 'Ingresar | Fpay Comercios',
    titleWording: 'documentTitle.login',
  },
  {
    screen: ['', '/home'],
    title: 'Inicio',
    titleWording: 'documentTitle.home',
  },
  {
    screen: [Routes.FORGOT_PASSWORD, Routes.RESEND, Routes.EMAIL_SENT, Routes.USER_RECOVERY],
    title: 'Restablecer contraseña',
    titleWording: 'documentTitle.recoverAccount',
  },

  {
    screen: [Routes.RESET_PASSWORD],
    title: 'Cambiar contraseña',
    titleWording: 'documentTitle.resetPassword',
  },
  {
    screen: [Routes.TRANSACTIONS],
    title: 'Transacciones',
    titleWording: 'documentTitle.transactions',
  },
  {
    screen: [Routes.FUNDS_OUT],
    title: titleFundsOut,
    titleWording: 'documentTitle.fundsOut',
  },
  {
    screen: [Routes.ADD_BANK_ACCOUNT],
    title: 'Cuenta bancaria',
    titleWording: 'documentTitle.addBankAccount',
  },
  {
    screen: [Routes.EDIT_BANK_ACCOUNT],
    title: 'Editar cuenta bancaria',
    titleWording: 'documentTitle.editBankAccount',
  },
  {
    screen: [Routes.DO_FUNDS_OUT],
    title: 'Monto a retirar',
    titleWording: 'documentTitle.doFundsOut',
  },
  {
    screen: [Routes.DOCUMENT],
    title: 'Documentación',
    titleWording: 'documentTitle.document',
  },
  {
    screen: [Routes.USERS],
    title: 'Colaboradores',
    titleWording: 'documentTitle.users',
  },
  {
    screen: [Routes.USER_DETAIL],
    title: 'Colaboradores',
    titleWording: 'documentTitle.users',
  },
  {
    screen: [Routes.COMMERCE_DATA],
    title: 'Datos del comercio',
    titleWording: 'documentTitle.commerceData',
  },
  {
    screen: [Routes.SETTLEMENT_CALENDAR],
    title: 'Calendario de liquidación',
    titleWording: 'documentTitle.settlementCalendar',
  },
  {
    screen: [Routes.LAST_MOVEMENTS],
    title: 'Movimientos de cuenta',
    titleWording: 'documentTitle.lastMovements',
  },
  {
    screen: [Routes.HELP],
    title: 'Ayuda',
    titleWording: 'documentTitle.help',
  },
];
